import $ from 'jquery';

$(() => {
  const $elements = $('.js-scroll-top');

  $elements.click((event) => {
    event.preventDefault();
    $('html, body').animate({ scrollTop: 0 });
  });
});



// WEBPACK FOOTER //
// ./js/components/init-scroll-up.js